import { useEffect } from 'react';

export function Device({ sendAnswer }) {
  useEffect(() => {
    sendAnswer(false);
  }, []);

  return (
    <p>
      This feature is only available on the SeamlessMD app. Press "Next" to
      continue the survey without connecting your device and enter your
      measurement on your own.
    </p>
  );
}
